import SectionCandicateBasicInfo from "../sections/profile/section-can-basic-info";
// import SectionCandidateSocialInfo from "../sections/profile/section-can-social-info";
import SectionScreeningQuetion from "../sections/profile/section-can-screeningquestions"
import { Helmet } from 'react-helmet-async';

function CanProfilePage() {
    return (
        <>
            <Helmet>
                <title>Profile | CV Diffusion</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>
            <div className="twm-right-section-panel site-bg-gray">

                {/*Basic Information*/}
                <SectionCandicateBasicInfo />

                {/*Social Network*/}
                {/* <SectionCandidateSocialInfo /> */}

                {/*Screening Questions*/}
                <SectionScreeningQuetion />

            </div>
        </>
    )
}

export default CanProfilePage;